module.exports = __webpack_public_path__ + "img/cl.dfe5e4b9.svg";